module.exports = __webpack_public_path__ + "static/work61-4c0a8e868e1c73326fee48c58a97b368.jpg";